
export const ZoomBesprechungstypen = ["MEETING", "WEBINAR"] as const;

type ZoomBesprechungstyp = typeof ZoomBesprechungstypen[number];

export default ZoomBesprechungstyp;
